import { Box, Button, Flex } from '@chakra-ui/react'
import { useState } from 'react'
import { WeekDaySelector } from '../WeekDaySelector'
import { TimeSelect } from '../../../common/TimeSelect'
import TimezoneSelect from 'react-timezone-select'
import { customStyles } from '../../../common/Select'

export const AddTime = ({ type, startTime, stopTime, onTimeChange }) => {
    const isEdit = type === 'start' ? !!startTime : !!stopTime
    const editTime = type === 'start' ? startTime : stopTime
    const [selectedDay, setSelectedDay] = useState(isEdit ? editTime.split(' ')[0] : '')
    const [selectedTime, setSelectedTime] = useState(isEdit ? editTime.split(' ')[1] : '00:00')
    const [selectedTimezone, setSelectedTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)

    const onTimeZoneChange = (timeZone) => {
        setSelectedTimezone(timeZone.value)
    }

    return (
        <Box display="flex" flexDir="column" alignItems="center" justifyContent="center">
            <WeekDaySelector onChange={setSelectedDay} selectedDays={selectedDay} />
            <Flex mb={4}>
                <TimeSelect type="00" mt={4} value={selectedTime} onChange={setSelectedTime} />
            </Flex>            
            <TimezoneSelect width="600px" styles={customStyles} value={selectedTimezone} onChange={onTimeZoneChange} />
            
            <Button 
                mt={4}
                onClick={() => onTimeChange(type, `${selectedDay} ${selectedTime} ${selectedTimezone}`)}
                isDisabled={!selectedDay}
            >
                ADD
            </Button>
        </Box>
    )
}
